<script>
export default {
    methods: {
        colorChange(val) {
            if(parseFloat(val) < 0) {
                return 'red !important'
            } else if (parseFloat(val) > 0) {
                return '#00B012 !important'
            } else {
                return '#000 !important'
            }
        }
    }
}
</script>